<template>
  <div class="time-sheet-entry-border" style="height: 100%;">
    <v-row>
      <v-col cols="12" class="text-center">
        <b>{{ entry.dayOfTheWeek }}</b>
        <br>
        <b>{{ entry.date | formatDate }}</b>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="pt-0">
        <FormattedNumberField
          :readonly="entry.blocked"
          :value="entry.hours"
          :required="false"
          :dense="true"
          :validateOnBlur="true"
          :hideDetails="true"
          @valueChange="timeValueChangeHandler"
        >
        </FormattedNumberField>
      </v-col>
      <!--<v-col cols="12" class="pt-0 text-center">
        <v-btn
          color="primary"
          outlined
          block
        >
          <v-icon color="primary">article</v-icon>
        </v-btn>
      </v-col>-->
    </v-row>
  </div>
</template>

<script>
import { SummaryItem } from '@/components/shared/display'
import { FormattedNumberField } from '@/components/shared/textFields'

export default {
  components: {
    SummaryItem,
    FormattedNumberField
  },
  props: [
    'entry'
  ],
  methods: {
    timeValueChangeHandler (newHoursValue) {
      if (newHoursValue !== null && newHoursValue !== undefined) {
        this.$emit('entryTimeChange', this.entry, newHoursValue)
      }
    }
  }
}
</script>

<style>
.time-sheet-entry-border {
  border: 0.1em solid #cccccc;
  border-radius: 7px;
  padding: 15px 10px;
}
</style>
